import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../store/config";
import ErrorModal from "../common/ErrorModal";

function LoginPassword() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);

  const navigate = useNavigate();

  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async () => {
    setApiError("");

    // ✅ Email validation
    if (!email.trim()) {
      setApiError("Email is required");
      setShowErrorModal(true);
      return;
    }

    if (!isValidEmail(email)) {
      setApiError("Enter a valid email");
      setShowErrorModal(true);
      return;
    }

    // ✅ Password validation
    if (!password) {
      setApiError("Password is required");
      setShowErrorModal(true);
      return;
    }

    if (password.length < 6) {
      setApiError("Password must be at least 6 characters");
      setShowErrorModal(true);
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(`${BASE_URL}api/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        setApiError(data?.detail || "Login failed");
        setShowErrorModal(true);
        return;
      }

      // ✅ SUCCESS FLOW (CRITICAL FIX)
      localStorage.setItem("access_token", data.access_token);
      localStorage.setItem("isLoggedIn", "true");

      localStorage.setItem(
        "first_time_user",
        data.is_first_user ? "True" : "False"
      );

      // 🔥 THIS LINE FIXES YOUR TEST
      navigate("/dashboard");

    } catch (err) {
      setApiError("Something went wrong. Please try again.");
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="input-group">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <div className="input-group">
        <input
          type={showPassword ? "text" : "password"}
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <span
          className="toggle-password"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? "👁️‍🗨️" : "👁"}
        </span>
      </div>

      <button
        className="btn"
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? "Logging in..." : "Continue"}
      </button>

      {/* ✅ Error Modal */}
      <ErrorModal
        show={showErrorModal}
        message={apiError}
        onClose={() => setShowErrorModal(false)}
      />
    </>
  );
}

export default LoginPassword;